import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiResponse } from "../../models/api-response.model";
import { ClientOnboardingChartData } from "../../../features/charts/client-onboarding-chart/models/ClientOnboardingChartData";
import { WageWithdrawalChartData } from "../../../features/charts/weekly-wage-withdrawal-chart/models/WageWithdrawalChartData";
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class ChartDataService {

    private readonly apiUrl = `${environment.apiGatewayBaseUrl}`;
    // private apiUrl = 'https://localhost:7050/api/ClientOnboarding/monthly-chart-data';
    // private apiUrl2 = 'https://localhost:7254/api/WageWithdrawals/weekly-chart-data';

    constructor(private http: HttpClient) { }

    getMonthlyChartData(startDate?: string, endDate?: string): Observable<ApiResponse<ClientOnboardingChartData>> {
        let params = new HttpParams();
        if (startDate) params = params.set('startDate', startDate);
        if (endDate) params = params.set('endDate', endDate);

        return this.http.get<ApiResponse<ClientOnboardingChartData>>(`${this.apiUrl}/ClientOnboarding/monthly-chart-data`, { params });
    }

    getWeeklyChartData(startDate?: string, endDate?: string): Observable<ApiResponse<WageWithdrawalChartData>> {
        let params = new HttpParams();
        if (startDate) params = params.set('startDate', startDate);
        if (endDate) params = params.set('endDate', endDate);

        return this.http.get<ApiResponse<WageWithdrawalChartData>>(`${this.apiUrl}/WageWithdrawals/weekly-chart-data`, { params });
    }

}